// biome-ignore lint/style/noRestrictedGlobals: encapsulation
export const hasOwnProperty = Object.hasOwn;
